function u(t, e) {
  return t !== e && e.startsWith(t.endsWith("/") ? t : `${t}/`);
}
function l(t) {
  const e = t.lastIndexOf("/");
  return e !== -1 ? t.substring(e + 1) : t;
}
function a(t) {
  const e = t.lastIndexOf("/");
  return e === 0 ? "/" : e !== -1 ? t.substring(0, e) : "/";
}
function d(t) {
  const e = t.split("/").reverse(), n = e[2] ? "..." : "", s = e[1] ? `/${e[1]}/` : "/";
  return `${n}${s}${e[0]}`;
}
function f(t) {
  return (t.match(/\//g) ?? []).length - 1;
}
function o(...t) {
  return t.reduce((e, n) => e && n ? `${e.replace(/\/$/g, "")}/${n.replace(/^\//g, "")}` : `${e}${n}`);
}
function x(t) {
  const e = [];
  let n = t.indexOf("/");
  for (; n !== -1; ) {
    const s = t.substring(0, n) || "/";
    if (e.push(s), n + 1 >= t.length)
      break;
    const i = t.indexOf("/", n + 1);
    n = i === -1 ? t.length : i;
  }
  return e;
}
function g(t) {
  const e = t.lastIndexOf(".");
  if (!(t.lastIndexOf("/") > e))
    return e !== -1 ? t.substring(e + 1) : void 0;
}
function h(t) {
  return /(^dockerfile$|\.dockerfile)$/i.test(t);
}
function $(t) {
  const e = t.lastIndexOf(".");
  return e !== -1 ? t.slice(0, e) : t;
}
function O(t) {
  const { name: e, extension: n } = t;
  return `${e}${n ? `.${n}` : ""}`;
}
function c(t) {
  const e = t.startsWith("/"), n = t.split("/"), s = [];
  for (const r of n)
    r === ".." ? s.length && s[s.length - 1] !== ".." ? s.pop() : e || s.push(r) : r !== "." && r !== "" && s.push(r);
  const i = s.join("/");
  return (e ? "/" : "") + i;
}
function F(...t) {
  return c(o(...t));
}
export {
  a,
  d as b,
  f as c,
  x as d,
  g as e,
  h as f,
  l as g,
  $ as h,
  u as i,
  o as j,
  O as k,
  F as r
};
//# sourceMappingURL=path.js.map
